import { __decorate } from "tslib";
import _ from 'lodash';
import { injectable } from '@/inversify.config';
export const AsideFolderSearchServiceSymbol = Symbol.for('AsideFolderSearchService');
let AsideFolderSearchService = class AsideFolderSearchService {
    constructor() {
        this._filter = '';
        this.debounceFilter = '';
        this.debounceUpdateFilter = _.debounce((str) => {
            this.debounceFilter = (str || '').trim();
        }, 500);
        this.isInSearchMode = false;
    }
    get filter() {
        return this._filter;
    }
    set filter(str) {
        this._filter = str;
        this.debounceUpdateFilter(str);
    }
    get filterWithTrim() {
        return this.filter.trim() || '';
    }
    reset() {
        this.isInSearchMode = false;
        this.filter = '';
    }
};
AsideFolderSearchService = __decorate([
    injectable()
], AsideFolderSearchService);
export { AsideFolderSearchService };
